// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"e3f6421e","703":"a82d35f4","787":"ecd94cda"}[chunkId] + ".chunk.js";
};